(function () {
  const DESKTOP = "(min-width: 990px)";

  function openFacetDetails(root) {
    const details = root.querySelectorAll("details");
    details.forEach((d) => {
      d.setAttribute("open", "open");

      // Keep open on desktop
      d.addEventListener("toggle", () => {
        if (!d.open && window.matchMedia(DESKTOP).matches) {
          d.setAttribute("open", "open");
        }
      });
    });
  }

  function lockFacetsOpenOnDesktop() {
    if (!window.matchMedia(DESKTOP).matches) return;

    // Dawn commonly renders facets in one of these:
    const candidates = [
      document.querySelector(".facets-vertical"),
      document.querySelector("#main-collection-filters"),
      document.querySelector(".product-grid-container"),
    ].filter(Boolean);

    candidates.forEach(openFacetDetails);
  }

  document.addEventListener("DOMContentLoaded", lockFacetsOpenOnDesktop);
  window.addEventListener("resize", lockFacetsOpenOnDesktop);
})();
